import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setPropTypes, defaultProps } from 'recompose';
import { getFormValues } from 'redux-form';

export default ({ fields = [], propName = 'formValues' } = {}) => {
  const mapStateToProps = (state, { form }) => {
    const allFormValues = getFormValues(form)(state);
    const formValues = _.isEmpty(fields)
      ? allFormValues
      : _.pick(allFormValues, fields);
    return {
      [propName]: formValues,
    };
  };

  return compose(
    connect(mapStateToProps),
    setPropTypes({
      [propName]: PropTypes.object,
    }),
    defaultProps({
      [propName]: {},
    }),
  );
};
